import userRoleService from '../../services/api/UserRole';
import callPrompts from '../../services/api/CallPrompts';
import commonFunctions from '../../mixin/common-function-mixins';
import { USER_ROLE_SAVE_ACTION, USER_ROLE_SUMMARY_ACTION, USER_ROLE_DELETE_ACTION, USER_ROLE_LOAD_STATUS_ACTION, USER_ROLE_LOAD_USER_ROLES_ACTION }  from '../action-types';
import { USER_ROLE_SUMMARY_MUTATION, USER_ROLE_IS_DISABLE_MUTATION, USER_ROLE_IS_VISIBLE_MUTATION, USER_ROLE_FIRST_NAME_CHANGED_MUTATION, 
    USER_ROLE_LAST_NAME_CHANGED_MUTATION, USER_ROLE_EMAIL_CHANGED_MUTATION, USER_ROLE_CHANGED_MUTATION,
    USER_ROLE_LOAD_STATUS_MUTATION, USER_ROLE_CLEAR_DATA_MUTATION, USER_ROLE_AUDIT_LOG_MUTATION, USER_ROLE_LOAD_USER_ROLES_MUTATION} from '../mutation-types';

export const namespaced = true;

// initial state
export const state = {
    namespaced: true,
    userRoleSummaryData : [],
    statusDetails: [],
    userRoleDetails: [],
    userRoleData: loadEmptyUserRole(),
    isVisible: false,
    isDisableButton: false,
};

// actions
export const actions = {
    async [USER_ROLE_SUMMARY_ACTION]({commit})  {
        const response = await userRoleService.getUserRoleSummary();
        commit(USER_ROLE_SUMMARY_MUTATION, response.data);
        return response;
    },
    async [USER_ROLE_LOAD_USER_ROLES_ACTION]({ commit }) {
        const response = await userRoleService.getTazUserRoles();
        commit(USER_ROLE_LOAD_USER_ROLES_MUTATION, response.data)
        return response;
    },
    async [USER_ROLE_LOAD_STATUS_ACTION]({ commit }) {
        const response = await callPrompts.getPromptStatuses();
        commit(USER_ROLE_LOAD_STATUS_MUTATION, response.data)
        return response;
    },
    async [USER_ROLE_SAVE_ACTION] ({state}){  
        const response = await userRoleService.saveUserToRole(state.userRoleData);    
        return response;
    },
    async [USER_ROLE_DELETE_ACTION]({state}, userToRole) {
        var requestData = { userToRole : userToRole, TazClientAuditLog: state.userRoleData.tazClientAuditLog}
        const response = await userRoleService.deleteUserRole(requestData);
        return response;
    }
}

// mutations
export const mutations = { 
    [USER_ROLE_SUMMARY_MUTATION](state, summaryData){
        summaryData.map(r =>{ r.ptCreatedDate = commonFunctions.methods.formatDate(r.ptCreatedDate, 'MM/DD/YYYY hh:mm A')});
        summaryData.map(r =>{ r.ptModifiedDate = commonFunctions.methods.formatDate(r.ptModifiedDate, 'MM/DD/YYYY hh:mm A')});
        summaryData.map(r =>{ r.statusName =  r.statusId == 1 ? 'Active': 'Inactive'})
        state.userRoleSummaryData = summaryData;
    },
    [USER_ROLE_LOAD_USER_ROLES_MUTATION](state, userRoleData){
        state.userRoleDetails = [];
        userRoleData.forEach(r => {
            if(r !='TazAffiliate' && r != 'None' ){ 
                state.userRoleDetails.push({userRole: r})
            }
        })
    },
    [USER_ROLE_LOAD_STATUS_MUTATION](state, statusDatas){
        state.statusDetails = statusDatas.filter(r => r.statusID <= 2);
    },
    [USER_ROLE_FIRST_NAME_CHANGED_MUTATION](state, firstName){
        state.userRoleData.userToRole.firstName = firstName;
    },
    [USER_ROLE_LAST_NAME_CHANGED_MUTATION](state, lastName){
        state.userRoleData.userToRole.lastName = lastName;
    },
    [USER_ROLE_EMAIL_CHANGED_MUTATION](state, email){
        state.userRoleData.userToRole.email = email;
    },
    [USER_ROLE_CHANGED_MUTATION](state, userRole){
        state.userRoleData.userToRole.userRole = userRole;
    },
    [USER_ROLE_IS_DISABLE_MUTATION](state, isDisable){
        state.isDisableButton = isDisable;
    },
    [USER_ROLE_IS_VISIBLE_MUTATION](state, isVisible){
        state.isVisible = isVisible;
    },
    [USER_ROLE_CLEAR_DATA_MUTATION](state){
        state.userRoleData = loadEmptyUserRole();
    },
    [USER_ROLE_AUDIT_LOG_MUTATION](state, tazClientAuditLog){
        state.userRoleData.tazClientAuditLog = tazClientAuditLog
    }
}
function loadEmptyUserRole(){
    return { 
        userToRole:{
            userToRoleId: 0,
            firstName: null,
            lastName: null,
            email: null,
            userRole: null,
            statusId: 1  //defalut active status
        }
    }
}